export default __webpack_public_path__ + "images/react/utils/LogoUtils/assets/onlinecitizenasia.com.png";